export const BD_GET_OFFERSTATUS_LISTING = "BD_GET_OFFERSTATUS_LISTING"
export const BD_GET_OFFERSTATUS_LISTING_SUCCESS = "BD_GET_OFFERSTATUS_LISTING_SUCCESS"
export const BD_GET_OFFERSTATUS_LISTING_FAILED = "BD_GET_OFFERSTATUS_LISTING_FAILED"